module.exports = __webpack_public_path__ + "static/media/edit-3.d098baf1.svg";